/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import Button from 'material/ctas/button/button_container';
// import Icon from 'material/graphic/icon/icon';
// styles
import injectSheet from 'react-jss';
import styles from 'material/ctas/edit/edit_styles';



/* ========== ~~~~~~~~~~ CTA : EDIT BUTTON  : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const EditButton = (props) => {
	return (
		<Button 
			type={`action`} 
			action={props.editInfo} 
			variant={`primary`} 
			name={`edit-information`} 
			text={`Edit Information`} 
			klass={props.classes.edit}
		/>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EditButton);